import { render } from "./OnboardingLegalRepresentativePage.vue?vue&type=template&id=8b6434ce&scoped=true"
import script from "./OnboardingLegalRepresentativePage.vue?vue&type=script&lang=js"
export * from "./OnboardingLegalRepresentativePage.vue?vue&type=script&lang=js"

import "./OnboardingLegalRepresentativePage.vue?vue&type=style&index=0&id=8b6434ce&lang=scss"
import "./OnboardingLegalRepresentativePage.vue?vue&type=style&index=1&id=8b6434ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6434ce"]])

export default __exports__